import { Visibility } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  MenuItem,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { json, Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../../utils/routes";
import {
  useDeleteBookingFacilityMutation,
  useGetBookingServicesQuery,
} from "../../../../../api/financeApi";
import { CalendarFilter2 } from "../../../../Components/Search/Search";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import { toast } from "react-toastify";
import {
  DeleteBookingService,
  GetAllBookingService,
} from "../../../../../../utils/redux/HR/HRSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../../utils/functions/FormatStatus";
import { FormatDateTimeV2 } from "../../../../../../utils/functions/ResourceFunctions";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  fontSize: "14px",
  fontWeight: "500",
  color: "#333",
  borderBottom: "none",
}));

const statusColors = {
  Active: "bg-green-100 text-green-700",
  Inactive: "bg-red-100 text-red-700",
  Maintenance: "bg-yellow-100 text-yellow-700",
};
const getStatusLabel = (status) => {
  if (status === 0) return "Inactive";
  if (status === 1) return "Active";
  if (status === 2) return "Maintenance";
};

const getStatusColor = (status) => {
  const label = getStatusLabel(status);
  return statusColors[label];
};

const MyBookings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [facilityId, setFacilityId] = useState();
  const userId = JSON.parse(localStorage.getItem("user"));

  const { data, isLoading, refetch } = useGetBookingServicesQuery({
    PageSize: rowsPerPage,
    PageNumber: page,
    Status: selectedStatus,
    RequisitorId: userId?.staffId,
    startDate: FormatDateTimeV2(startDate),
    endDate: FormatDateTimeV2(endDate),
  });
  const tableData = data?.result?.items;
  const tablePagination = data?.result;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      const res = await dispatch(
        DeleteBookingService({
          id: facilityId,
        })
      ).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        handleClose();
        refetch();
        setDeleteLoading(false);
      } else {
        toast.error(res?.statusMessage);
        setDeleteLoading(false);
      }
    } catch (error) {
      setDeleteLoading(false);
      toast.error("An error occurred while deleting the booking facility.");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  const filterBy = [
    // {
    //   name: "All",
    //   filter: 411,
    // },
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <div>
      <div>
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center gap-3">
            <div className="flex flex-col">
              <span>Search</span>
              <TextField
                label="Search"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                size="small"
              />
            </div>
            <CalendarFilter2
              name="Select Date Range"
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
            <div className="flex flex-col">
              <span>Status</span>
              <TextField
                select
                label="Status"
                value={selectedStatus}
                onChange={handleStatusChange}
                variant="outlined"
                size="small"
                sx={{
                  width: 216,
                }}
              >
                <MenuItem></MenuItem>
                {filterBy.map((item) => (
                  <MenuItem key={item.filter} value={item.filter}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
          <Button
            variant="contained"
            onClick={() =>
              navigate("/dashboard/finance/" + URL.CreateNewService)
            }
            style={{ backgroundColor: "#305F32", color: "#fff" }}
          >
            Book A Service
          </Button>
        </div>
        {isLoading && <p>Loading...</p>}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>S/N</StyledTableCell>
                <StyledTableCell>Requisitor Name</StyledTableCell>
                <StyledTableCell>Service ID</StyledTableCell>
                <StyledTableCell>Facility ID</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
                <StyledTableCell>Date Requested</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((row, index) => (
                <TableRow key={row.id}>
                  <StyledTableCell>{index + 1}</StyledTableCell>
                  <StyledTableCell>{row?.requisitorName}</StyledTableCell>
                  <StyledTableCell>{row?.serviceId}</StyledTableCell>
                  <StyledTableCell>{row?.facilityId}</StyledTableCell>
                  <StyledTableCell>
                    {new Date(row?.startDate).toLocaleDateString()}{" "}
                    {new Date(row?.startDate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </StyledTableCell>
                  <StyledTableCell>
                    {new Date(row?.endDate).toLocaleDateString()}{" "}
                    {new Date(row?.endDate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </StyledTableCell>

                  <StyledTableCell>
                    {new Date(row?.createdDate).toLocaleDateString()}
                  </StyledTableCell>
                  <StyledTableCell>
                    <span
                      // className={`rounded-full px-2 py-1 ${getStatusColor(
                      //   row?.approvalStatus
                      // )}`}
                      style={{
                        color: getColorByStatus(row?.approvalStatus).color,
                        backgroundColor: getColorByStatus(row?.approvalStatus)
                          .backgroundColor,
                        padding: "4px", // Optional padding for better visual presentation
                        borderRadius: "4px", // Optional rounded corners
                      }}
                    >
                      {FormatStatus(row?.approvalStatus)}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell>
                    <div className="flex items-center">
                      <button
                        onClick={() => {
                          console.log(row, "this is a new role");
                          navigate(
                            "/dashboard/finance/Bookings-Service-Details/" +
                              row?.id
                          );
                        }}
                        className="bg-[#6E9170] rounded-l-md p-1"
                      >
                        <Visibility className="text-[#fff]" />
                      </button>
                      <div onClick={() => setFacilityId(row?.id)}>
                        <button
                          onClick={handleClick}
                          className="bg-[#4B664C] p-1 rounded-r-md"
                        >
                          <KeyboardArrowDownIcon className="text-[#fff]" />
                        </button>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className="p-3 flex flex-col gap-8 h-[100px] w-[120px]">
            <div className="flex gap-3 items-center">
              <img
                className="w-[14px] h-[14px]"
                src={editIcon}
                alt="edit con"
              />
              <Link
                to={`/dashboard/finance/${URL.UpdateServiceBookings}/${facilityId}`}
                className="text-[#4B664C] hover:text-[#305F32]"
              >
                Update
              </Link>
            </div>
            {/* <div className="flex gap-3 items-center">
              <Visibility className="w-[14px] h-[14px]" />
              <Link
                to={`/dashboard/finance/${URL.BookingsServiceDetails}`}
                className="text-[#4B664C] hover:text-[#305F32]"
              >
                View
              </Link>
            </div> */}
            <div className="flex gap-3 items-center">
              <img className="w-[14px] h-[14px]" src={bin} alt="delete icon" />
              <button onClick={handleDelete} disabled={deleteLoading}>
                {deleteLoading ? "Deleting..." : "Delete"}{" "}
              </button>
            </div>
          </div>
        </Popover>
        {/* <TablePagination
          component="div"
          count={tablePagination.totalCount} // Total number of items
          page={page} // Current page (0-indexed)
          onPageChange={handleChangePage} // Function to handle page change
          rowsPerPage={rowsPerPage} // Current rows per page
          onRowsPerPageChange={handleChangeRowsPerPage} // Function to handle rows per page change
          rowsPerPageOptions={[5, 10, 25]} // Options for rows per page
          className="mt-4"
        /> */}
      </div>
    </div>
  );
};

export default MyBookings;
